export default class Buyer {
    fullName        = null;
    dateBirth       = null;
    cpf             = null;
    cnpj            = null;
    phone           = null;
    email           = null;
    companyName     = null;
    //confirmEmail    = null;

    //telefone        = null;
    

    constructor(){ }
}



    